module.exports = __webpack_public_path__ + "img/lifestyle.52254d52.jpg";